module.exports = __webpack_public_path__ + "static/media/Sucre.002af166.jpg";